import React from 'react'

const ExpiredLicense = ({ userEmail, license }) => {
  const isNoLicense = license === 'no-license';
  const isExpiredEnterprise = license === 'expired-enterprise';

  return (
    <div className="expired-license-container">
      <h4>Hi, {userEmail}</h4>
      
      <p>
        {isNoLicense ? (
          'No license detected for your account.'
        ) : (
          <>
            Your {isExpiredEnterprise ? 'enterprise license' : 'free trial'} has expired.
          </>
        )}
      </p>
        <br/>
        <br/>
      <div className="contact-info">
        <span>Contact us: </span>
        <a href="mailto:appsupport@eswlab.com">appsupport@eswlab.com</a>
      </div>
    </div>
  );
}



export default ExpiredLicense
